import React from 'react'
import { OutlinedTextFieldProps, TextField, Typography } from '@mui/material'
import { colors } from 'src/theme'
import tw from 'twin.macro'

export interface BasicTextAreaProps<T>
  extends Omit<OutlinedTextFieldProps, 'name' | 'variant' | 'label'> {
  name: keyof T
  label?: string
  minRows?: number
}

export const BasicTextArea = <T extends unknown>({
  name,
  label,
  minRows = 4,
  css,
  ...rest
}: BasicTextAreaProps<T>) => {
  return (
    <div css={css}>
      <Typography css={tw`mb-1`} variant="h6" color={colors.GRAY_COOL_GRAY}>
        {label}
      </Typography>
      <TextField
        name={name as string}
        variant="outlined"
        placeholder={label}
        multiline
        minRows={minRows}
        {...rest}
      />
    </div>
  )
}
